import { Injectable } from '@angular/core';
import { Action, State, Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class Dispatcher {
  constructor(private store: Store<State<any>>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
